module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-13.4272f5e9.png";